/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Collapse, Skeleton } from "antd";

import cone from "../../../static/images/cone.png";
import { faqCategoriesFetchRequest } from "../../../store/faq/actions";
import { RootState } from "../../../store/root_reducer";

import styles from "./styles.module.css";

export const FAQContainer: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("faq_page");

  const state = useSelector((root: RootState) => root.FAQ);

  useEffect(() => {
    dispatch(faqCategoriesFetchRequest());
  }, [dispatch, i18n.language]);

  return (
    <>
      <section className={styles.header}>
        <div>
          <h1>{t("title")}</h1>
          <p>{t("subTitle")}</p>
        </div>
        <img alt={t("imgAlt")} src={cone} />
      </section>

      <section className={styles.content}>
        <Collapse ghost className={styles.collapse}>
          {state.isCategoriesLoading &&
            [...Array(10)].map((e, i) => (
              <Collapse.Panel
                key={i}
                collapsible="disabled"
                className={styles.panel}
                header={<Skeleton title={false} active paragraph={{ rows: 1, width: "100%" }} />}
              />
            ))}

          {!state.isCategoriesLoading &&
            state.categories.map((category, idx) => (
              <Collapse.Panel key={idx} header={category.title} className={styles.panel}>
                {category.articles.map((article, articleIdx) => (
                  <Link key={articleIdx} className={styles.link} to={`/faq/${article.slug}`}>
                    <h3>{article.title}</h3>
                  </Link>
                ))}
              </Collapse.Panel>
            ))}
        </Collapse>
        <div className={styles.rightSide}>{children}</div>
      </section>
    </>
  );
};
